import { IApplicationState } from '../../types/redux';

export function selectPagination(state: IApplicationState) {
  const { page, total, limit } = state.buildersProjects.data;

  return { page, total, limit };
}
